import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import FromTemplate from '../../../components/PublicationCreator/FromTemplate';
import { PublicationCreationStatus } from '../reducer';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		publicationCreator: {
			source,
			fromTemplate: {
				selectedTemplate,
				name,
				error,
			},
			fromFile: {
				status,
				percentage,
				error: importingError,
			},
		},
	} = state;

	return {
		...ownProps,
		source,
		selectedTemplate,
		name,
		error,
		isImportingFile: status && [
			PublicationCreationStatus.IMPORTING,
			PublicationCreationStatus.PROCESSING,
		].includes(status),
		importingStatus: status,
		importingPercentage: percentage,
		importingError,
	};
};

export default connect(mapStateToProps)(FromTemplate);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/PublicationCreator/FromTemplate/index.tsx